import React, { useEffect, useState } from 'react';
import { getRecoveryConfig, getSchoolYear } from '../../Api';

// Lembrete para a direção/secretaria configurar a recuperação do ano.
// Aparece ao entrar no sistema enquanto não houver configuração; "Lembrar depois" esconde até o próximo login.
export const CHAVE_LEMBRETE_RECUPERACAO = 'recuperacao-lembrete-fechado';
const GESTORES = ['DIRETOR/SUPERVISOR', 'SECRETARIO'];

export function RecoveryReminder() {
    const [aberto, setAberto] = useState(false);
    const [ano, setAno] = useState('');

    useEffect(() => {
        let ativo = true;
        (async () => {
            try {
                if (sessionStorage.getItem(CHAVE_LEMBRETE_RECUPERACAO) === '1') return;
                if (!sessionStorage.getItem('token')) return;
                if (window.location.pathname === '/recovery-config') return; // já está configurando
                if (!GESTORES.includes(localStorage.getItem('position_at_school'))) return;
                if (localStorage.getItem('positionAtEducationDepartment')) return;
                if (sessionStorage.getItem('assessmentFormat') !== 'grade') return; // recuperação é para escolas com nota
                const idSchool = JSON.parse(sessionStorage.getItem('id-school') || 'null');
                if (!idSchool) return;
                const sy = await getSchoolYear(idSchool);
                const year = sy?.data?.data;
                if (!year) return;
                const r = await getRecoveryConfig(idSchool, year);
                if (ativo && !r?.data?.config) {
                    setAno(String(year));
                    setAberto(true);
                }
            } catch { /* sem lembrete se falhar */ }
        })();
        return () => { ativo = false; };
    }, []);

    // nunca por cima da própria tela de configuração
    if (!aberto || window.location.pathname === '/recovery-config') return null;

    const lembrarDepois = () => {
        try { sessionStorage.setItem(CHAVE_LEMBRETE_RECUPERACAO, '1'); } catch { /* ignore */ }
        setAberto(false);
    };

    return (
        <div style={{
            position: 'fixed', inset: 0, zIndex: 3000, background: 'rgba(0,0,0,.45)',
            backdropFilter: 'blur(6px)', WebkitBackdropFilter: 'blur(6px)',
            display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16,
        }}>
            <div role="alertdialog" aria-modal="true" style={{
                width: '100%', maxWidth: 460, boxSizing: 'border-box', background: 'var(--surface, #fff)',
                color: 'var(--text, #16323b)', borderRadius: 14, borderTop: '6px solid var(--orange, #e67e22)',
                boxShadow: '0 20px 50px rgba(0,0,0,.3)', padding: '24px 24px 20px', fontSize: 15, lineHeight: 1.6,
            }}>
                <div style={{ fontSize: 38, textAlign: 'center' }}>⚠️</div>
                <h3 style={{ margin: '6px 0 10px', textAlign: 'center', color: 'var(--orange, #d35400)' }}>
                    A recuperação de {ano} ainda não foi configurada
                </h3>
                <p style={{ margin: '0 0 18px' }}>
                    Defina como a nota de recuperação entra no boletim. Enquanto não configurar,
                    os professores não conseguem lançar recuperação e as notas continuam como estão.
                </p>
                <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
                    <button type="button" onClick={lembrarDepois} style={{
                        minWidth: 140, padding: '12px 20px', borderRadius: 10, cursor: 'pointer',
                        border: '1px solid var(--line, #d0d7db)', background: 'transparent', color: 'var(--text, #16323b)', fontWeight: 700,
                    }}>Lembrar depois</button>
                    <button type="button" autoFocus onClick={() => { setAberto(false); window.location.href = '/recovery-config'; }} style={{
                        minWidth: 140, padding: '12px 20px', borderRadius: 10, cursor: 'pointer', border: 'none',
                        background: 'var(--orange, #e67e22)', color: '#fff', fontWeight: 800,
                    }}>Configurar agora</button>
                </div>
            </div>
        </div>
    );
}

export default RecoveryReminder;
